<template>
  <div
    class="subscribe-bg"
    :class="[theme]"
  >
    <div class="subscribe-bg-image">
      <div class="home-content">
        <slot name="subscribe-content" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "KabSubscribe",
  props: {
    theme: {
      type: String,
      default: 'primary'
    }
  }
}
</script>
<style lang="scss" scoped>
.home-content {
  margin: -25px 13% auto 13%;
}
.subscribe-bg {
  &.primary {
    background-color: #c2c2c2;
    .subscribe-bg-image {
      background: url('../assets/subscribe-bg@2x.jpg');
      background-size: cover;
    }
  }
  &.accent {
    background-color: #6a0043;
    .subscribe-bg-image {
      background: url('../assets/scan-text-2@2x.png');
      background-size: cover;
    }
  }
}
</style>